import { Identifier, randomUUID } from "../core";
export class PModifierItemInstanceId extends Identifier {
    constructor() {
        super("PModifierItemInstanceId", randomUUID());
    }
}
